import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgScrollRegular = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19.5 13.5H18v-6C18 6.122 16.878 5 15.5 5h-10A2.503 2.503 0 0 0 3 7.5V9a1.5 1.5 0 0 0 1.5 1.5h1V9h-1V7.5c0-.55.45-1 1-1s1 .45 1 1v9C6.5 17.878 7.622 19 9 19h8.331A3.674 3.674 0 0 0 21 15.331V15a1.5 1.5 0 0 0-1.5-1.5m-9.5 1v2c0 .55-.45 1-1 1s-1-.45-1-1v-9c0-.356-.077-.693-.212-1H15.5c.55 0 1 .45 1 1v6H11c-.553 0-1 .447-1 1m9.5.831a2.17 2.17 0 0 1-2.169 2.169h-6.043c.134-.306.212-.644.212-1V15h8z"
    }));
export default SvgScrollRegular;
